import React, { Fragment, useEffect, useRef, useState } from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import { Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Button } from "reactstrap";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";

import { mapOrderReturnResponseToTable } from "../../../../utils/mapper";
import { useDispatch, useSelector } from "react-redux";
import withReducer from "../../../../store/withReducer";

import { addReturnItems, calculateRefundAllocation, getOrderSettings, setRefundsData, setSettings, showReturnList } from "../../store/orderSlice";
import { declineScanReturn } from "../../store/returnOrderSlice";
import { useHistory, useParams, Link } from "react-router-dom";

import orderReducer from "../../store";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import PreLoader from "../../../../share-components/ui/preLoader";
import ItemsTable from "./ItemsTable";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { currencyFormatter, currencySymbol, formatterDecimal, formatterDecimalValue } from "../../../../utils/common";
import { RefundedItem } from "../../view-order/section/refundedItem";
import RefundAllocation from "../content/refundAllocation";

const toMoneyNumber = (value) => {
  const number = parseFloat(value);
  return Number.isNaN(number) ? 0 : Math.round(number * 100) / 100;
};

const ReturnOrder = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  let history = useHistory();

  const currentUser = useSelector(({ authReducer }) => authReducer.data.user);
  const isDirectPermission = currentUser.role.name !== "Seller" && currentUser.permission.includes("Direct Refund");
  const [loading, isSetLoading] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [declineButtonDisabled, setDeclineButtonDisabled] = useState(false);
  const [orderItems, setOrderItems] = useState([]);

  const [packList, setPackList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  // Add after: const [suggestedTotalRefund, setSuggestedTotalRefund] = useState(0);

  const [allocationLimits, setAllocationLimits] = useState({
    giftCardMax: 0,
    cardMax: 0,
    isMixedPayment: false,
    suggestedTotal: 0,
    gateways: [],
  });
  const [allocationLoading, setAllocationLoading] = useState(false);
  const [allocationData, setAllocationData] = useState(null);
  const [shouldCalculate, setsShouldCalculate] = useState(false);
  const orderState = useSelector(({ order }) => order.order);

  useEffect(() => {
    dispatch(getOrderSettings()).then((res) => {
      if (!res.error) {
        const results = {
          settings: res.payload,
          id: null,
        };
        dispatch(setSettings(res.payload));
      }
    });
  }, [dispatch]);

  const dataMenu = [
    {
      type: 1,
      text: "Orders",
      link: "/order",
    },
    {
      type: 0,
      text: "Return Order",
    },
  ];

  useEffect(() => {
    dispatch(showReturnList(id)).then((res) => {
      if (!res.error) {
        dispatch(setRefundsData(res.payload));

        const items = mapOrderReturnResponseToTable(res.payload.list);
        setOrderItems(items);

        isSetLoading(false);

        if (isDirectPermission && res.payload.list.length == 0) {
          setIsDirectRefund(true);
        }
      }
    });
  }, [dispatch]);

  const [isDirectRefund, setIsDirectRefund] = useState(false);
  const [refundAmountDisabled, setRefundAmountDisabled] = useState(false);
  const [isSelectedRows, setIsSelectedRows] = useState(false);
  const [isItemEditable, setIsItemEditable] = useState(false);
  const [isShowRestock, setIsShowRestock] = useState(false);
  const [shippingRate, setShippingRate] = useState("");
  const [totalRefund, setTotalRefund] = useState(0);
  const [suggestedTotalRefund, setSuggestedTotalRefund] = useState(0);
  // Money-only refund from the order's remaining balance, excluding shipping (see hasBalanceRefund)
  const [balanceAmount, setBalanceAmount] = useState("");

  const [refundData, setRefundData] = useState({
    currency: "GBP",
    balance_shipping_rate: 0,
    balance_shipping_rate_format: "0.00",
    balance_refund: 0,
    balance_refund_format: "0.00",
    refunded_items_balance: 0,
    refunded_items_balance_format: "0.00",
  });

  const hasRefundItems = orderItems.some(
        item => item.selected && Number(item.quantity) > 0
    );

  // Currency axis. For a USD/EUR order every amount on this page (item totals, shipping, balance and the
  // Shopify refund split) is entered and shown in the order's presentment currency — what the customer paid.
  // Balances arrive in GBP plus presentment equivalents (presentment = GBP × currency_rate); amount_currency
  // tells the server to convert the entered amounts back to GBP (GBP = presentment ÷ currency_rate).
  const presentmentCurrency = String(refundData.currency || "GBP").toUpperCase();
  const isForeignOrder = presentmentCurrency !== "GBP";
  const currencyRate = Number(refundData.currency_rate);
  // A non-GBP order with no rate cannot be converted; the server rejects it as well
  const isMissingRate = isForeignOrder && !(currencyRate > 0);
  const missingRateMessage = `This ${presentmentCurrency} order has no currency rate, so the refund cannot be converted to GBP. Please contact support.`;
  const isPresentmentAxis = isForeignOrder && !isMissingRate;
  const displayCurrency = isPresentmentAxis ? presentmentCurrency : "GBP";
  const moneyFormatter = currencyFormatter(displayCurrency);
  const moneySymbol = currencySymbol(displayCurrency);
  // WHY: GBP ceiling messages keep their original wording (no symbol); foreign ones name the currency
  const ceilingText = (formattedAmount) => (isPresentmentAxis ? moneySymbol : "") + formattedAmount;

  // Remaining refundable after prior refunds, on the input axis
  const shippingCeiling = isPresentmentAxis ? Number(refundData.balance_shipping_rate_presentment) || 0 : refundData.balance_shipping_rate;
  const shippingCeilingFormat = isPresentmentAxis ? refundData.balance_shipping_rate_presentment_format : refundData.balance_shipping_rate_format;
  const refundCeiling = isPresentmentAxis ? Number(refundData.balance_refund_presentment) || 0 : refundData.balance_refund;
  const refundCeilingFormat = isPresentmentAxis ? refundData.balance_refund_presentment_format : refundData.balance_refund_format;

  // Money-only direct refund (no items selected) can be taken from the order's remaining balance, excluding shipping (refunded via its own input)
  const balanceRefundExShipping = Math.max(toMoneyNumber(refundCeiling - shippingCeiling), 0);
  const balanceRefundExShippingFormat = balanceRefundExShipping.toFixed(2);
  const hasBalanceRefund = balanceRefundExShipping > 0;
  // Some items were refunded for less than was paid for them; shipping has its own balance
  const hasRefundedItemsBalance = refundData.refunded_items_balance > 0;
  const refundedItemsBalanceFormat = isPresentmentAxis
    ? formatterDecimal.format(toMoneyNumber(refundData.refunded_items_balance * currencyRate))
    : refundData.refunded_items_balance_format;
  const [serverError, setServerError] = useState("");

  useEffect(() => {
    if (orderState.refund_balance_details) {
      setRefundData(orderState.refund_balance_details);
    }
  }, [orderState.refund_balance_details]);

  // Add after: useEffect(() => { calcTotalRefundAmount(); }, [orderItems, shippingRate]);
  useEffect(() => {
    if (!shouldCalculate) {
      return;
    }
    if (!isDirectRefund) {
      setAllocationLimits({ giftCardMax: 0, cardMax: 0, isMixedPayment: false, suggestedTotal: 0, gateways: [] });
      setAllocationData(null);
      return;
    }

    const selectedItems = orderItems.filter((item) => item.selected === true && item.quantity > 0);

    // Allow shipping-only calculation
    const hasShipping = toMoneyNumber(shippingRate) > 0;

    if (selectedItems.length === 0 && !hasShipping) {
      setAllocationLimits({ giftCardMax: 0, cardMax: 0, isMixedPayment: false, suggestedTotal: 0, gateways: [] });
      setAllocationData(null);
      return;
    }

    const lineItems = selectedItems.map((item) => ({
      line_item_id: item.id,
      quantity: item.quantity,
    }));

    setAllocationLoading(true);

    dispatch(calculateRefundAllocation({ orderId: orderState.data.order_no, lineItems }))
      .then((res) => {
        if (!res.error) {
          setAllocationLimits({
            giftCardMax: res.payload.gift_card_max,
            cardMax: res.payload.card_max,
            isMixedPayment: res.payload.is_mixed_payment,
            suggestedTotal: res.payload.suggested_total,
            gateways: res.payload.gateways || [],
          });
          setSuggestedTotalRefund(res.payload.suggested_total || 0);
        }
      })
      .finally(() => {
        setAllocationLoading(false);
        setsShouldCalculate(false);
      });
  }, [orderItems, isDirectRefund, shouldCalculate]);

  /**
   * Form Validation Schema
   */
  const schema = yup.object().shape({
    shipping_refund_amount: yup
      .number()
      .transform((value, originalValue) => (String(originalValue).trim() === "" ? null : value))
      .max(shippingCeiling, "The amount must be " + ceilingText(shippingCeilingFormat) + " or less")
      .min(0, "The amount cannot be negative")
      .nullable(),
    total_refund_amount: yup
      .number()
      .transform((value, originalValue) => (String(originalValue).trim() === "" ? null : value))
      .max(refundCeiling, "The amount must be " + ceilingText(refundCeilingFormat) + " or less")
      .min(
        orderItems.length === 0 && isDirectRefund === true && refundData.balance_shipping_rate === 0 ? 0.01 : 0,
        orderItems.length === 0 && isDirectRefund === true ? "The amount must be greater than 0" : "The amount must be at least 0",
      )
      .nullable()
      .required("Refund amount is a required field"),
    balance_refund_amount: yup
      .number()
      .transform((value, originalValue) => (String(originalValue).trim() === "" ? null : value))
      .max(balanceRefundExShipping, "The amount must be " + ceilingText(balanceRefundExShippingFormat) + " or less")
      .moreThan(0, "The amount must be greater than 0")
      .nullable(),
  });

  const defaultValues = {
    shipping_refund_amount: null,
    total_refund_amount: null,
    reason: null,
    is_notify: false,
    is_direct_refund: false,
  };

  const { handleSubmit, formState, reset, control, register, setValue, trigger, getValues } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { errors, isDirty } = formState;

  const [errorShipRate, setErrorShipRate] = useState("");

  const shippingHandleChange = (event) => {
    // Get the value from the input
    let newValue = parseFloat(event.target.value);

    // Round the value to two decimal places
    if (!isNaN(newValue)) {
      newValue = parseFloat(newValue.toFixed(2));
    } else {
      newValue = "";
    }

    setShippingRate(newValue);
    setValue("shipping_refund_amount", newValue);
    trigger("shipping_refund_amount");

    // Only trigger allocation recalculation if there's actually shipping left to refund
    if (shippingCeiling > 0) {
        setsShouldCalculate(true);
    }

    let mgs = "";
    if (newValue < 0) {
      mgs = "The amount cannot be negative";
    } else if (newValue > 0 && newValue > shippingCeiling) {
      mgs = `The amount must be ${ceilingText(shippingCeilingFormat)} or less`;
    }

    setErrorShipRate(mgs);
  };

  const shippingHandleBlur = (event) => {
    // Get the value from the input
    let newValue = parseFloat(event.target.value);

    // Round the value to two decimal places
    if (!isNaN(newValue)) {
      newValue = formatterDecimalValue(newValue);
    } else {
      newValue = "";
    }

    setShippingRate(newValue);
    setValue("shipping_refund_amount", newValue);
    trigger("shipping_refund_amount");
  };

  const refundHandleChange = (event) => {
    // Get the value from the input
    let newValue = parseFloat(event.target.value);

    // Round the value to two decimal places
    if (!isNaN(newValue)) {
      newValue = parseFloat(newValue.toFixed(2));
    } else {
      newValue = "";
    }

    setTotalRefund(event.target.value);
    setValue("total_refund_amount", newValue);
    trigger("total_refund_amount");
  };

  const refundHandleBlur = (event) => {
    // Get the value from the input
    let newValue = parseFloat(event.target.value);

    // Round the value to two decimal places
    if (!isNaN(newValue)) {
      // newValue = formatterDecimalValue(newValue);
      newValue = parseFloat(newValue.toFixed(2));
    } else {
      newValue = "";
    }

    setTotalRefund(formatterDecimalValue(newValue));
    setValue("total_refund_amount", newValue);
    trigger("total_refund_amount");
  };

  const calcTotalRefundAmount = () => {
    let total = 0;
    let countSelectedItem = 0;
    orderItems.forEach((item, i) => {
      if (item.selected === true) {
        countSelectedItem += 1;
        total += Number(item.returnTotal);
      }
    });

    total += Number(shippingRate);
    // The balance is refunded separately from items (its input is disabled while items are selected)
    if (hasBalanceRefund && countSelectedItem === 0) {
      total += Number(balanceAmount);
    }
    // WHY: round, not floor - every part is already 2dp, and float sums like 19.99 (1998.9999…) would otherwise lose a penny
    const display = (Math.round(total * 100) / 100).toFixed(2);
    setTotalRefund(display);
    setSuggestedTotalRefund(display);
    setRefundAmountDisabled(countSelectedItem > 0);
    setIsSelectedRows(countSelectedItem > 0);
  };

  useEffect(() => {
    calcTotalRefundAmount();
  }, [orderItems, shippingRate, balanceAmount, hasBalanceRefund]);

  const setBalance = (value) => {
    setBalanceAmount(value);
    setValue("balance_refund_amount", value);
    trigger("balance_refund_amount");
  };

  const balanceHandleChange = (event) => {
    if (/^\d*\.?\d{0,2}$/.test(event.target.value)) {
      setBalance(event.target.value);
    }
  };

  const balanceHandleBlur = () => {
    setBalance(balanceAmount === "" ? "" : toMoneyNumber(balanceAmount).toFixed(2));
  };

  useEffect(() => {
    if ((hasRefundItems || !isDirectRefund) && balanceAmount !== "") {
      setBalance("");
    }
  }, [hasRefundItems, isDirectRefund]);

  useEffect(() => {
    let isItemEdit = orderItems ? orderItems.some((item) => !(item.return_request_id || item.made_to_measure_request_id || item.cancel_request_id || item.refund_request_id)) : false;
    setIsItemEditable(isItemEdit);

    let _isShowRestock = orderItems ? orderItems.some((item) => item.is_goddiva === false) : false;
    setIsShowRestock(_isShowRestock);
  }, [orderItems]);

  useEffect(() => {
    if (!isDirectRefund) {
      const updatedItems = orderItems.map((item) => ({
        ...item,
        selected: false,
        quantity: 0,
        returnTotal: 0.0,
        returnTotalFormat: formatterDecimal.format(0),
        reason: "",
        reason_id: null,
        isRestock: false,
      }));
      setOrderItems(updatedItems);
    }
  }, [isDirectRefund]);

  const submitData = () => {
    let isError = false;
    let returnItems = [];
    let errorMessage = "";

    if (isDirectRefund) {
      if (isMissingRate) {
        errorMessage = missingRateMessage;
        isError = true;
      } else if (Number(shippingRate) < 0) {
        errorMessage = "The amount cannot be negative";
        isError = true;
      } else if (shippingRate > 0 && shippingRate > shippingCeiling) {
        errorMessage = `The amount must be ${ceilingText(shippingCeilingFormat)} or less`;
        isError = true;
      } else if (hasBalanceRefund && errors.balance_refund_amount) {
        errorMessage = errors.balance_refund_amount.message;
        isError = true;
      }
    }

    if (isError) {
      setErrorShipRate(errorMessage);
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    }

    if (isDirectRefund && allocationData && allocationData.isValid === false) {
      toast.error("Invalid refund allocation, please check the refund split", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    }

    const updatedItems = orderItems.map((item) => {
      let itemErrors = {
        isError: false,
        isErrorReason: false,
        isErrorQty: false,
        isErrorReturnTotal: false,
      };

      if (item.selected === true) {
        if (item.reason_id === null) itemErrors.isErrorReason = true;
        if (parseFloat(item.quantity) === 0) itemErrors.isErrorQty = true;
        if (parseFloat(item.quantity) > parseFloat(item.availableQuantity)) itemErrors.isErrorQty = true;
        if (parseFloat(item.returnTotal) < 0) itemErrors.isErrorReturnTotal = true;

        returnItems.push({
          line_item_id: item.id,
          quantity: item.quantity,
          return_total: item.returnTotal,
          restock: item.isRestock ? item.isRestock : false,
          reason_id: item.reason_id,
        });
      }

      itemErrors.isError = itemErrors.isErrorReason || itemErrors.isErrorQty || itemErrors.isErrorReturnTotal;

      if (itemErrors.isError) isError = true;

      return { ...item, itemErrors: itemErrors };
    });

    setOrderItems(updatedItems);

    if (isError) {
      toast.error("Invalid submission, please check all required fields", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    }

    // Validation
    if (!isDirectRefund && returnItems.length == 0) {
      toast.error("Please select at least one item", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    } else if (isDirectRefund && totalRefund <= 0) {
      toast.error("The refund amount must be greater than 0", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    } else if (isError) {
      toast.error("Invalid submission, please check all required fields", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    }

    returnOrRefund(returnItems);
  };

  const returnOrRefund = (items) => {
    SweetAlert.fire({
      title: "Are you sure want to return this product?",
      text: "Once confirmed, the return request will be sent to the system",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Proceed",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setButtonDisabled(true);
        // WHY: a balance refund has no line items, so the allocation has no gateways and totalAllocated is 0; the backend auto-distributes totalRefund instead
        const isBalanceOnlySubmit = hasBalanceRefund && !hasRefundItems && toMoneyNumber(balanceAmount) > 0;
        const effectiveTotalRefund = isDirectRefund && !isBalanceOnlySubmit && allocationData && allocationData.totalAllocated != null ? allocationData.totalAllocated : totalRefund;

        let data = {
          order_id: id,
          is_direct_refund: isDirectRefund,
          shipping_refund_amount: shippingRate,
          total_refund_amount: effectiveTotalRefund,
          is_notify: getValues("is_notify"),
          reason: getValues("reason"),
          items: items,
          refund_allocation: allocationData,
          // Amounts above are in the presentment currency for a USD/EUR order; GBP orders post exactly as before
          ...(isPresentmentAxis ? { amount_currency: presentmentCurrency } : {}),
        };
        setServerError("");
        dispatch(addReturnItems(data))
          .then((res) => {
            setButtonDisabled(false);
            if (!res.error) {
              history.push(`/order/${id}/view`);
            } else if (isDirectRefund && res.error.message) {
              // The server's message is already in the entered currency (e.g. "… less than or equal to $270.00")
              setServerError(res.error.message);
            }
          })
          .catch((e) => setButtonDisabled(false));
      }
    });
  };

  const handleDeclineItems = () => {
    let isError = false;
    let declineItems = [];

    const updatedItems = orderItems.map((item) => {
      let itemErrors = {
        isError: false,
        isErrorReason: false,
        isErrorQty: false,
      };

      if (item.selected === true) {
        if (item.reason_id === null) itemErrors.isErrorReason = true;
        if (parseFloat(item.quantity) === 0) itemErrors.isErrorQty = true;
        if (parseFloat(item.quantity) > parseFloat(item.availableQuantity)) itemErrors.isErrorQty = true;

        declineItems.push({
          line_item_id: item.id,
          quantity: item.quantity,
          reason_id: item.reason_id,
        });
      }

      itemErrors.isError = itemErrors.isErrorReason || itemErrors.isErrorQty;

      if (itemErrors.isError) isError = true;

      return { ...item, itemErrors: itemErrors };
    });

    setOrderItems(updatedItems);

    if (isError) {
      toast.error("Invalid submission, please check all required fields", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    }

    if (declineItems.length == 0) {
      toast.error("Please select at least one item", {
        position: toast.POSITION.TOP_RIGHT,
      });

      return;
    }

    declineOrder(declineItems);
  };

  const declineOrder = (items) => {
    const willReduceStock = orderState.data && orderState.data.reduce_stock_on_decline;
    const declineText = willReduceStock
      ? "This will decline the return and reduce marketplace stock for the declined quantity, as configured for this partner. This cannot be undone."
      : "This will decline the return. Stock will not be adjusted, as this partner is not configured to reduce stock on decline. This cannot be undone.";

    SweetAlert.fire({
      title: "Are you sure want to decline the selected item(s)?",
      text: declineText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Decline",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setDeclineButtonDisabled(true);

        let data = {
          order_id: id,
          reason_id: items[0].reason_id,
          items: items,
        };

        dispatch(declineScanReturn(data))
          .then((res) => {
            setDeclineButtonDisabled(false);
            if (!res.error) {
              history.push(`/order/${id}/view`);
            }
          })
          .catch((e) => setDeclineButtonDisabled(false));
      }
    });
  };

  // WHY: without the Direct Refund permission the order balance can't be refunded here, so only the refunded-items notice keeps the page open
  const isFullyRefunded = orderItems.length === 0 && refundData.balance_shipping_rate === 0 && !hasRefundedItemsBalance && !(isDirectPermission && hasBalanceRefund);
  const showAllocation = isDirectRefund && (orderItems.length > 0 || refundData.balance_shipping_rate > 0 || hasBalanceRefund);

  return (
    <Fragment>
      {loading ? (
        <>
          <PreLoader></PreLoader>
        </>
      ) : (
        <>
          <Breadcrumb title="Select Order Items for Returns" data={dataMenu} />
          <Container fluid={true}>
            <Row>
              <Col md={showAllocation ? 8 : 12}>
                <Card className="ribbon-wrapper">
                  <CardBody>
                    <div className="ribbon ribbon-clip h6 ribbon-primary">Items from Order {orderState.data ? orderState.data.order_name : ""}</div>

                    {orderState.data && !orderState.data.is_active_date && (
                      <div
                        style={{
                          color: "rgb(255, 0, 0)",
                          borderRadius: 3,
                          border: "1px solid rgb(255, 0, 0)",
                        }}
                        className="mb-3 p-3"
                      >
                        <p>
                          <b>Return period expired:</b> this order was placed on {orderState.data.order_date} ({orderState.data.days_since_order} day
                          {orderState.data.days_since_order === 1 ? "" : "s"} ago). The return policy for this order allows {orderState.data.allowed_return_period_days} day
                          {orderState.data.allowed_return_period_days === 1 ? "" : "s"} (deadline {orderState.data.allowed_return_period_date}) - it is{" "}
                          {orderState.data.days_since_order - orderState.data.allowed_return_period_days} day
                          {orderState.data.days_since_order - orderState.data.allowed_return_period_days === 1 ? "" : "s"} overdue.
                        </p>
                      </div>
                    )}

                    {!isFullyRefunded ? (
                      <>
                        {orderItems.length > 0 && (
                          <div className="mb-4">
                            {orderItems.some((item) => item.is_outlet) && orderState.data.partner_id == 24 && (
                              <div
                                style={{
                                  color: "rgb(255, 0, 0)",
                                  borderRadius: 3,
                                  border: "1px solid rgb(255, 0, 0)",
                                }}
                                className="mb-3 p-3"
                              >
                                <p>
                                  This order includes one or more <b>Outlet items</b>. Returns for Outlet items will be refunded as a regular refund because we got this order from{" "}
                                  <b>"Superdrug" Marketplace</b>.
                                  {isDirectPermission && (
                                    <>
                                      {" "}
                                      To issue a full refund, please select the <b>Direct Refund</b> option below.
                                    </>
                                  )}
                                </p>
                              </div>
                            )}

                            {isDirectPermission && (
                              <>
                                <div className="checkbox checkbox-dark mb-3">
                                  <input
                                    id="is_direct_refund"
                                    type="checkbox"
                                    onChange={(e) => {
                                      setIsDirectRefund(e.target.checked);
                                      // trigger('is_direct_refund');
                                    }}
                                    defaultChecked={isDirectRefund}
                                  />
                                  <Label for="is_direct_refund">
                                    <strong>Direct Refund</strong>
                                  </Label>
                                </div>
                              </>
                            )}

                            <ItemsTable
                              orderItems={orderItems}
                              orderState={orderState}
                              isDirectRefund={isDirectRefund}
                              setOrderItems={setOrderItems}
                              isItemEditable={isItemEditable}
                              isShowRestock={isShowRestock}
                              setsShouldCalculate={setsShouldCalculate}
                              moneySymbol={moneySymbol}
                              priceRate={isPresentmentAxis ? currencyRate : null}
                            />
                          </div>
                        )}

                        {hasRefundedItemsBalance && !isDirectPermission && (
                          <div className="alert alert-info mb-3" role="alert">
                            Items already refunded on this order have <b>{moneySymbol}{refundedItemsBalanceFormat}</b> still unrefunded. Refunding it requires the{" "}
                            <b>Direct Refund</b> permission — please ask a user with that permission to process it.
                          </div>
                        )}

                        {isDirectRefund && (refundData.balance_shipping_rate > 0 || orderItems.some((i) => i.selected) || hasBalanceRefund) && (
                          <>
                            {isMissingRate && (
                              <div className="alert alert-danger mb-3" role="alert">
                                {missingRateMessage}
                              </div>
                            )}
                            {serverError && (
                              <div className="alert alert-danger mb-3" role="alert">
                                {serverError}
                              </div>
                            )}
                            <Row>
                              <Col md={4}>
                                {refundData.balance_shipping_rate > 0 && (
                                  <>
                                    <h6 className="mb-2">Refund shipping</h6>
                                    <p>Shipping rate: Standard ({moneySymbol}{shippingCeilingFormat})</p>
                                    <FormGroup className="mt-2">
                                      <Label>Refund amount ({moneySymbol})</Label>
                                      <input
                                        type="number"
                                        min={0}
                                        step="any"
                                        placeholder="Enter refund shipping amount"
                                        className={"form-control " + (errorShipRate ? "is-invalid" : "")}
                                        value={shippingRate}
                                        onChange={shippingHandleChange}
                                        onBlur={shippingHandleBlur}
                                      />
                                      <small className="form-text text-muted">{moneySymbol}{shippingCeilingFormat} available for shipping refund</small>
                                      {errorShipRate && <div className="invalid-feedback">{errorShipRate}</div>}
                                    </FormGroup>
                                  </>
                                )}

                                {hasBalanceRefund && (
                                  <>
                                    <h6 className="mb-2">Refund remaining balance</h6>
                                    <p>{moneySymbol}{balanceRefundExShippingFormat} balance remaining on this order (excluding shipping)</p>
                                    <FormGroup className="mt-2">
                                      <Label>Refund amount ({moneySymbol})</Label>
                                      <input
                                        type="text"
                                        inputMode="decimal"
                                        placeholder="Enter refund amount"
                                        className={"form-control " + (errors.balance_refund_amount ? "is-invalid" : "")}
                                        value={balanceAmount}
                                        onChange={balanceHandleChange}
                                        onBlur={balanceHandleBlur}
                                        disabled={hasRefundItems}
                                      />
                                      <small className="form-text text-muted">
                                        {hasRefundItems
                                          ? "Clear the item selection to refund this balance separately"
                                          : `${moneyFormatter.format(balanceRefundExShipping)} available for refund`}
                                      </small>
                                      {errors.balance_refund_amount && <div className="invalid-feedback">{errors.balance_refund_amount.message}</div>}
                                    </FormGroup>
                                  </>
                                )}

                                <h6 className="mb-2">Reason for refund</h6>
                                <FormGroup>
                                  <input type="text" className="form-control" placeholder="Enter reason" {...register("reason")} />
                                  <small className="form-text text-muted">Only you and other staff can see this reason.</small>
                                </FormGroup>
                              </Col>

                              <Col md={4}></Col>
                            </Row>
                          </>
                        )}

                        {!isDirectRefund && isSelectedRows && (
                          <>
                            <div className="mt-2 d-flex justify-content-end">
                              <div className="p-2">
                                <ButtonLoader
                                  disabled={buttonDisabled || declineButtonDisabled}
                                  onClick={handleDeclineItems}
                                  btntext="Decline"
                                  className="btn btn-danger btn-block"
                                />
                              </div>
                              <div className="p-2">
                                <ButtonLoader disabled={buttonDisabled || declineButtonDisabled} onClick={submitData} btntext="Return" className="btn btn-primary btn-block" />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {currentUser.role.name !== "Seller" ? (
                          <>
                            <p className="text-danger">All the items from this order have been refunded already.</p>
                          </>
                        ) : (
                          <>
                            <p className="text-danger">Already refunded or permission denied.</p>
                          </>
                        )}
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>

              {showAllocation && (
                <Col md={4}>
                  <RefundAllocation
                    totalRefund={totalRefund}
                    giftCardMax={allocationLimits.giftCardMax}
                    cardMax={allocationLimits.cardMax}
                    isMixedPayment={allocationLimits.isMixedPayment}
                    gateways={allocationLimits.gateways}
                    hasGiftCardPayment={allocationLimits.giftCardMax > 0}
                    isLoading={allocationLoading}
                    onAllocationChange={setAllocationData}
                    suggestedTotalRefund={suggestedTotalRefund}
                    setValue={setValue}
                    getValues={getValues}
                    buttonDisabled={buttonDisabled}
                    submitData={submitData}
                    suggestedTotalRefund={allocationLimits.suggestedTotal}
                    shippingAmount={parseFloat(shippingRate) || 0}
                    isShippingOnly={orderItems.filter((i) => i.selected).length === 0}
                    hasRefundItems={hasRefundItems}
                    currency={displayCurrency}
                  />
                </Col>
              )}
            </Row>

            {currentUser.role.name !== "Seller" && <RefundedItem orderState={orderState} />}
          </Container>
        </>
      )}
    </Fragment>
  );
};

export default withReducer([{ order: orderReducer }])(ReturnOrder);
